export const generalLive = form => ["InternalBeta", "AutoReplySafeOnly"].includes(form.aiAutoReplyMode);
export const qualificationLive = form => form.leadQualificationAutoReplyMode === "InternalBeta";
export const controlledLive = form => form.leadQualificationControlledAnswerLiveMode === "LiveForSelectedScenarios";
export const anyLive = form => generalLive(form) || qualificationLive(form) || controlledLive(form);

export function capabilityDependencies(form) {
  if (!form.isEnabled) return [];
  const errors = [];
  if (["Live", "Primary"].includes(form.leadQualificationPlannerMode) && !qualificationLive(form)) {
    errors.push({ field: "leadQualificationPlannerMode", message: "Live qualification planning requires Lead Qualification Auto-Reply Mode = InternalBeta. Choose Shadow/Off or enable qualification sending." });
  }
  if ((qualificationLive(form) || controlledLive(form)) && !form.leadQualificationDryRunEnabled) {
    errors.push({ field: "leadQualificationDryRunEnabled", message: "Enable lead qualification evaluation before activating qualification or controlled-answer sending." });
  }
  if (form.businessHoursOnly && anyLive(form)) {
    errors.push({ field: "businessHoursOnly", message: "Business-hours scheduling is unavailable. Turn off Business hours only before activating sending." });
  }
  return errors;
}

export function newSendingCapabilities(form, saved) {
  if (!form.isEnabled) return [];
  const prior = saved?.isEnabled ? saved : null;
  const changes = [];
  if (generalLive(form) && (!prior || prior.aiAutoReplyMode !== form.aiAutoReplyMode)) {
    changes.push({ key: form.aiAutoReplyMode === "AutoReplySafeOnly" ? "safeOnly" : "internalBeta", label: form.aiAutoReplyMode === "AutoReplySafeOnly" ? "Approved knowledge answers (SafeOnly)" : "Internal beta answers" });
  }
  if (qualificationLive(form) && (!prior || !qualificationLive(prior))) changes.push({ key: "qualification", label: "Lead qualification replies" });
  if (controlledLive(form) && (!prior || !controlledLive(prior))) changes.push({ key: "controlledAnswers", label: "Approved configured answers" });
  if (anyLive(form) && form.approvedMediaAutoSendEnabled && (!prior || !prior.approvedMediaAutoSendEnabled || !anyLive(prior))) changes.push({ key: "media", label: "Approved media messages" });
  return changes;
}

export function capabilityReadiness(rollout, key, form) {
  const capability = Array.isArray(rollout?.capabilities) ? rollout.capabilities.find(item => item?.key === key) : null;
  if (!capability || !["Ready", "Blocked"].includes(capability.state) || !Array.isArray(capability.checks) || !capability.checks.length || capability.checks.some(check => !check || typeof check !== "object")) {
    return { state: "Unknown", checks: [], message: "Could not check readiness. Refresh checks after updating the API." };
  }
  const checks = capability.checks.map(check => {
    if (!check.settingName || check.requiredValue == null) return check;
    const value = check.settingName === "liveSending" ? anyLive(form) : form[check.settingName];
    if (value == null) return { ...check, passed: undefined };
    const passed = String(value).toLowerCase() === String(check.requiredValue).toLowerCase();
    return { ...check, passed, message: passed ? null : check.failureMessage || check.message || `${check.label} is required.` };
  });
  const state = checks.some(check => check.passed === false) ? "Blocked"
    : checks.some(check => check.passed !== true) ? "Unknown" : "Ready";
  return { state, checks, message: checks.find(check => check.passed !== true)?.message || (state === "Unknown" ? "Could not check readiness." : null) };
}
